<template>
    <van-popup class="controlsBox" v-model="show" position="bottom" :lock-scroll="true">
        <van-datetime-picker v-model="currentDate" type="date" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
</template>
<script>
export default {
    name: 'DatePicker',
    data() {
        return {
            currentDate: new Date(),
            show: false,
            callBack: function () { }
        }
    },
    created() {
        // ep.tail('publicControls', (source = [], selectedKey, onSuccess, onFail) => {
        //     this.columns = source || []
        //     this.onSuccess = onSuccess || function() {}
        //     this.onFail = onFail || function() {}
        // })
    },
    methods: {
        onSuccess(data) {
            this.callBack(data)
        },
        onFail(data) { },
        onConfirm(value) {
            this.show = false
            let newDate = this.getNowDate()
            this.onSuccess(newDate)
        },
        getNowDate() {
            let date = this.currentDate
            let sign1 = '-'
            let year = date.getFullYear() // 年
            let month = date.getMonth() + 1 // 月
            let day = date.getDate() // 日
            // 给一位数数据前面加 “0”
            if (month >= 1 && month <= 9) {
                month = '0' + month
            }
            if (day >= 0 && day <= 9) {
                day = '0' + day
            }
            let currentdate = year + sign1 + month + sign1 + day
            return currentdate
        },
        onCancel() {
            this.show = false
            this.onFail({})
        },
        getTime(next) {
            this.show = true
            if (next) {
                this.callBack = next
            } else {
                this.callBack = function () { }
            }
        }
    },
    components: {

    }
}
</script>
<style lang='less' rel='stylesheet/less' scoped>
.controlsBox {
    width: 100%;
    height: 40%;
    background: white;
}
</style>
